export default "https://cdn.questicon.mathletics.com/assets/images/Star-half-4ea4fb2fcb28b48e926dfafbed68e025.svg";